import React, { useState } from "react";
import DatePicker from "react-datepicker";
import moment from "moment";
import { RotaButtonIcon } from "@teamrota/rota-design";
import { useMutation } from "@apollo/client";

import {
  StyledInput,
  StyledP,
  StyledHoursWorkedHeader,
  StyledExceptionsContainer,
  StyledCircle,
  StyledSmallBoldP,
  StyledPlus,
  StyledException,
  StyledCount,
  StyledRowContainer,
  StyledErrorMessage
} from "./styles";

import ADD_MEMBER_AVAILABILITY_EXCEPTIONS from "./graphql/add-member-availability-exceptions";
import DELETE_MEMBER_AVAILABILITY_EXCEPTIONS from "./graphql/delete-member-availability-exceptions";

const ExceptionDates = ({
  memberAvailabilityExceptions,
  memberId,
  isLimitedHours
}) => {
  const [exceptions, setExceptions] = useState(
    memberAvailabilityExceptions || []
  );
  const [exceptionStartDate, setExceptionStartDate] = useState(
    new Date().toISOString()
  );
  const [exceptionEndDate, setExceptionEndDate] = useState(
    new Date().toISOString()
  );
  const [error, setError] = useState("");

  const [addMemberAvailabilityExceptions] = useMutation(
    ADD_MEMBER_AVAILABILITY_EXCEPTIONS
  );

  const [deleteMemberAvailabilityExceptions] = useMutation(
    DELETE_MEMBER_AVAILABILITY_EXCEPTIONS
  );

  const updateExceptionStartDate = value => {
    setError("");
    if (moment(value).isBefore(moment(exceptionEndDate))) {
      setExceptionStartDate(value);
    } else {
      setError("start date must be before end date");
    }
  };

  const updateExceptionEndDate = value => {
    setError("");
    if (moment(value).isAfter(moment(exceptionStartDate))) {
      setExceptionEndDate(value);
    } else {
      setError("end date must be after start date");
    }
  };

  const handleAddException = () => {
    if (!isLimitedHours) return;
    setExceptions(exceptions => [
      ...exceptions,
      {
        startDate: exceptionStartDate,
        endDate: exceptionEndDate
      }
    ]);
    addMemberAvailabilityExceptions({
      variables: {
        memberId,
        startDate: exceptionStartDate,
        endDate: exceptionEndDate
      }
    });
  };

  const handleDeleteException = idx => {
    const id = exceptions[idx]?.id;
    setExceptions(data => {
      const exceptions = [...data];
      exceptions.splice(idx, 1);
      return exceptions;
    });
    if (id) deleteMemberAvailabilityExceptions({ variables: { id } });
  };

  return (
    <>
      <StyledRowContainer>
        <StyledP disabled={!isLimitedHours}>
          Number of Exemption Periods:
          <StyledCount disabled={!isLimitedHours}>
            {exceptions?.length || 0}
          </StyledCount>
        </StyledP>
      </StyledRowContainer>
      <StyledHoursWorkedHeader>
        <StyledP disabled={!isLimitedHours} style={{ paddingRight: "5px" }}>
          Add dates:
        </StyledP>
        <StyledSmallBoldP disabled={!isLimitedHours}>from</StyledSmallBoldP>
        <DatePicker
          placeholderText={"Start date"}
          onChange={date => {
            updateExceptionStartDate(
              new Date(date.setHours(0, 0, 0, 0)).toISOString()
            );
          }}
          selected={new Date(exceptionStartDate)}
          todayButton={true}
          disabled={!isLimitedHours}
          showYearDropdown
          adjustDateOnChange
          dateFormat="dd/MM/yyyy"
          customInput={<StyledInput disabled={!isLimitedHours} />}
        />
        <StyledSmallBoldP disabled={!isLimitedHours}>until</StyledSmallBoldP>
        <DatePicker
          onChange={date => {
            updateExceptionEndDate(
              new Date(date.setHours(23, 59, 59, 999)).toISOString()
            );
          }}
          disabled={!isLimitedHours}
          placeholderText={"End date"}
          showYearDropdown
          adjustDateOnChange
          selected={new Date(exceptionEndDate)}
          dateFormat="dd/MM/yyyy"
          customInput={<StyledInput disabled={!isLimitedHours} />}
        />
        <StyledCircle disabled={!isLimitedHours} onClick={handleAddException}>
          <StyledPlus>+</StyledPlus>
        </StyledCircle>
        <StyledErrorMessage>{error}</StyledErrorMessage>
      </StyledHoursWorkedHeader>
      {isLimitedHours && exceptions.length ? (
        <StyledExceptionsContainer>
          {exceptions.map(({ startDate, endDate }, idx) => (
            <StyledException key={idx}>
              <p>{`${new Date(startDate).toLocaleDateString()} -
              ${new Date(endDate).toLocaleDateString()}`}</p>
              <RotaButtonIcon
                icon="close"
                onClick={() => handleDeleteException(idx)}
              />
            </StyledException>
          ))}
        </StyledExceptionsContainer>
      ) : (
        <StyledP
          disabled={!isLimitedHours}
          style={{ paddingRight: "5px", fontStyle: "italic" }}
        >
          Click on + to add exception
        </StyledP>
      )}
    </>
  );
};

export default ExceptionDates;
